import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import api from '../../api/axios';
import './PaymentReturn.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentReturn = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing'); // processing | success | error
    const [message, setMessage] = useState('Zahlung wird überprüft...');

    useEffect(() => {
        const clientSecret = searchParams.get('payment_intent_client_secret');
        const eventid = searchParams.get('eventid');

        if (!clientSecret) {
            setStatus('error');
            setMessage('Ungültige Zahlungssitzung.');
            return;
        }

        const verifyPayment = async () => {
            try {
                const stripe = await stripePromise;
                const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

                if (paymentIntent.status === 'succeeded') {
                    // Confirm on backend to book the event
                    await api.post('/user/stripe/confirm-payment', {
                        paymentIntentId: paymentIntent.id,
                        eventid: eventid,
                    });

                    setStatus('success');
                    setMessage('Zahlung erfolgreich! Du wirst weitergeleitet...');

                    setTimeout(() => {
                        navigate('/profile');
                    }, 2000);
                } else if (paymentIntent.status === 'processing') {
                    setStatus('processing');
                    setMessage('Zahlung wird noch verarbeitet. Bitte warte einen Moment...');
                } else {
                    setStatus('error');
                    setMessage('Zahlung fehlgeschlagen. Bitte versuche es erneut.');
                }
            } catch (err) {
                console.error('Error verifying payment:', err);
                setStatus('error');
                setMessage(err.response?.data?.error || 'Fehler bei der Zahlungsbestätigung.');
            }
        };

        verifyPayment();
    }, [searchParams, navigate]);

    return (
        <div className="payment-return-container">
            <div className="payment-return-card">
                {status === 'processing' && (
                    <div className="payment-return-spinner"></div>
                )}
                {status === 'success' && (
                    <div className="payment-return-icon success">✓</div>
                )}
                {status === 'error' && (
                    <div className="payment-return-icon error">✗</div>
                )}
                <p className={`payment-return-message ${status}`}>{message}</p>
                {status === 'error' && (
                    <button onClick={() => navigate('/eventsstore')} className="payment-return-button">
                        {t('PaymentReturnButton')}
                    </button>
                )}
            </div>
        </div>
    );
};

export default PaymentReturn;
